import { lazy } from 'react';

export const CatalogSearchPageAsync = lazy(() => import('./CatalogSearch'));
